import HTMLReactParser from "html-react-parser";
import convertTagsToHTML from "helpers/convertTagsToHtml";
import MCQOptions from "./MCQOptions";

const QuestionContent = ({ parsedXML }) => {
  const isMCQ = parsedXML?.questionType === "1";
  return (
    <div>
      {HTMLReactParser(convertTagsToHTML(parsedXML.questionContent))}
      {isMCQ && <MCQOptions data={parsedXML.mcqOptions}></MCQOptions>}
    </div>
  );
};

export default QuestionContent;
